import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

export const get_godown_list = createAsyncThunk("godownslist", async (data) => {
  console.log(data);
  const body = new FormData();
  body.append("userid", 1);
  body.append("ingress", 1);
  body.append("page", data.page);
  body.append("limit", data.rows);
  const response = await fetch(baseUrl + "godownslist", {
    method: "POST",
    body: body,
  });
  const res = await response.json();
  console.log(res);
  return res;
});

const initialState = {
  godown_list: [],
  loading: false,
  total_godown_count: 0,
};
const godownSlice = createSlice({
  name: "users",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(get_godown_list.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(get_godown_list.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(get_godown_list.fulfilled, (state, action) => {
      state.loading = false;
      const data = action.payload;
      state.loading = false;
      if (data.success) {
        state.total_godown_count = data.totalcount;
        state.godown_list = data.reponselist;
      } else {
        state.godown_list = [];
      }
    });
  },
});
export default godownSlice.reducer;
